/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymarketEligibilityField {
    CITY = 'city',
    STATE = 'state',
    COUNTRY = 'country',
    REGION = 'region',
    DEPARTMENT = 'department',
    BUSINESS_UNIT = 'businessUnit',
    CUSTOM_FIELD = 'customField',
    WORK_LOCATION = 'workLocation',
}
